import Link, { styles } from './Link';

export { styles };
export default Link;
